import React, { } from 'react'
import './styles.scss'
import { removeLastClosingPTag } from 'utils/helpers'
import VideoCallButton from '../VideoCallButton'
import { useDispatch } from 'react-redux'
import inchatActions from 'redux/inchat/actions'

const UserOptions = ({ conversationId, composer }) => {
  const dispatch = useDispatch()

  const insertTextInComposer = (message, isThread) => {
    const _message = composer?.message ? removeLastClosingPTag(composer?.message) + ' ' + message + '</p>' : message
    dispatch(inchatActions.editMessage({
      message: _message,
      isThread,
      messageId: composer.messageId,
      external: true,
      parentId: undefined,
      conversationId: conversationId,
    }))
  }

  return (
    <div className='inchat-user-options'>
      <VideoCallButton
        conversationId={conversationId}
        insertTextInComposer={insertTextInComposer}
      />
    </div>
  )
}

export default UserOptions
